import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,  // タイムアウトを15秒に延長
  headers: {
    'Content-Type': 'application/json',
  }
});

export default api;





